import { isObjectArrayWithNesting, rankWith } from "@jsonforms/core";

export const arrayLayoutTester = rankWith(5, isObjectArrayWithNesting);
